import cardValidator from 'card-validator';
import type { FieldValues, UseFormSetError } from 'react-hook-form';

import type { Parameter } from '../store/models';

type SubmitValidationOpts = {
  shouldValidateCard?: boolean;
  cardFieldName?: string;
  amount?: number;
};

export const hasValidationError = (
  fields: FieldValues,
  setError: UseFormSetError<FieldValues>,
  opts: SubmitValidationOpts = {},
): boolean => {
  const { shouldValidateCard, cardFieldName, amount } = opts;

  if (
    shouldValidateCard &&
    cardFieldName &&
    fields[cardFieldName] &&
    !cardValidator.number(fields[cardFieldName]).isValid
  ) {
    setError(`${cardFieldName}`, {
      type: 'manual',
    });
    return true;
  }

  if (!amount) {
    setError('amount', {
      type: 'manual',
    });
    return true;
  }

  return false;
};

export const getSelectedOption = (field: Parameter) => {
  if (field.type !== 'select') {
    return '';
  }

  const { options } = field;

  if (options?.length === 1) {
    return {
      value: options[0].value,
      label: options[0].label || '',
    };
  }

  if (options && options?.length > 1) {
    const selectedValue = options.find((option) => option.is_selected);
    if (selectedValue?.value) {
      return {
        value: selectedValue.value,
        label: selectedValue.label || '',
      };
    }
  }

  return '';
};
